/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const MyCalendarAssignmentDto = zod.object({
  "branchId": zod.number().optional(),
  "branchName": zod.string().optional(),
  "date": zod.coerce.date().optional(),
  "fromSchedule": zod.coerce.date().optional(),
  "toSchedule": zod.coerce.date().optional(),
  "isDeleted": zod.boolean().optional()
});

export type MyCalendarAssignmentDto = zod.input<typeof MyCalendarAssignmentDto>;
export type MyCalendarAssignmentDtoOutput = zod.output<typeof MyCalendarAssignmentDto>;
